"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const General_1 = require("../types/General");
const eventsAreLegacyEvents_1 = __importDefault(require("./eventsAreLegacyEvents"));
const controlEventsEnsureNoLegacy = (events) => {
    if ((0, eventsAreLegacyEvents_1.default)(events)) {
        return events.reduce((accum, legacyEvent) => (Object.assign(Object.assign({}, accum), { [legacyEvent.type]: {
                [General_1.DEFINITION_PROP_NAMES.IS_NEW]: 1,
                [General_1.DEFINITION_PROP_NAMES.FUNCTION_IDS]: legacyEvent.process,
            } })), {});
    }
    return events;
};
exports.default = controlEventsEnsureNoLegacy;
